import { useAppDispatch } from 'libraries/redux'
import styles from './BasketCard.module.scss'

import { DeleteIcon } from 'assets'
import { updateBasket, deleteBasket } from 'store/wishlist/actions'

const BasketCard = ({ data }: any) => {
  const dispatch = useAppDispatch()
  const { product, option } = data

  const updateCartCount = (id: number, count: number) => {
    dispatch(updateBasket({ id, body: { quantity: count } }))
  }

  const deleteCart = (id: number) => {
    dispatch(deleteBasket(id))
  }

  const renderOptions = option.map((option: any) => (
    <div className={styles.wrapper_option} key={option.id}>
      <div className={styles.wrapper_option__info}>
        <p>Розмір: {option.value}</p>
      </div>
      <div className={styles.wrapper_option__count}>
        <div className={styles.counter}>
          <button onClick={() => updateCartCount(option.id, option.quantity - 1)} className={styles.counter_item}>
            -
          </button>
          <div className={styles.counter_count}>{option.quantity}</div>
          <button onClick={() => updateCartCount(option.id, option.quantity + 1)} className={styles.counter_item}>
            +
          </button>
        </div>
        <DeleteIcon onClick={() => deleteCart(option.id)} />
      </div>
    </div>
  ))

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_image}>
        <img src={product.thumb} alt={product.name} />
      </div>
      <div className={styles.wrapper_content}>
        <div className={styles.wrapper_name}>
          <p className={styles.wrapper_title}>{product.name}</p>
          <p>{product.special ?? product.price}</p>
        </div>
        {renderOptions}
      </div>
    </div>
  )
}

export default BasketCard
